"use client";
import { useEffect, useState } from "react";
import FixFooter from "@/components/fixFooter";
import logo_bigger from "@/assets/images/logo_bigger.png";
import scanCode from "@/assets/images/scanCode.png";
import { concatInfo, footerNavList, friendLinkList, footerNavList800 } from "@/constants/header";
import { Col, Row, Collapse } from "antd";
import { Fragment } from "react";
import styles from "./index.module.scss";
import { getInnerWidth } from "@/utils/commonHooks";
export default function Footer() {
  const [visible, setVis] = useState(false);
  const pcWidth = getInnerWidth();
  function scrollFn() {
    var scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    if (1100 <= scrollTop) {
      setVis(true);
    } else {
      setVis(false);
    }
  }

  useEffect(() => {
    scrollFn()
    window.addEventListener("scroll", scrollFn);
    return () => {
      window.removeEventListener("scroll", scrollFn);
    };
  }, []);
  return (
    <div>
      {visible && <FixFooter />}
      <div className="wrapper hCenter">
        <img src={logo_bigger.src} className={styles.logoBig} alt="" />
        <div className={styles.logoBigBox}></div>
        {pcWidth == 'mini' && <Collapse ghost expandIconPosition='end' accordion>
          {
            footerNavList800 && footerNavList800.map((item, k) => {
              return (
                <Collapse.Panel
                  className={styles.footerNav}
                  header={
                    <div style={{ fontWeight: 500 }}>
                      <span>{item.title}</span>
                    </div>
                  }
                  key={k}>
                  {
                    item.children.map((c: any, i: number) => {
                      return (
                        <a href={c.href} key={i}>
                          {c.title}
                        </a>
                      )
                    })
                  }
                </Collapse.Panel>
              )
            })
          }

        </Collapse>}
        {pcWidth == 'pc' && <Row className={styles.footerNav} gutter={[0, 20]} justify={"center"}>
          {footerNavList.map((nav: any, key: number) => {
            return (
              <Col lg={nav.colspanlg||4} md={nav.colspanlg||4} sm={nav.colspan||4} xs={nav.colspan||4} key={key}>

                {key===0&&<img src={logo_bigger.src} className={styles.logoPc} alt="" />}
                <label>{nav.title}</label>
                {nav.children.map((n: any, i: number) => {
                  return (
                    <a href={n.href} key={i}>
                      {n.title}
                    </a>
                  );
                })}
              </Col>
            );
          })}

          <Col lg={8} md={8} sm={16} xs={16}>
            <label>{concatInfo.title}</label>
            {concatInfo.list.map((info: any, key: number) => {
              return (
                <p key={key}>
                  <span className={styles.tit}>{info.tit}</span>

                  {info.href ? (
                    <a href={info.href} className={styles.cont}>
                      {info.content}
                    </a>
                  ) : (
                    <span className={styles.cont}>{info.content}</span>
                  )}
                </p>
              );
            })}
            <div className={styles.scanBox}>
              扫码关注
              <div className={styles.wxIcon}>
                <div className={styles.codeBox}>
                  <img src={scanCode.src} className={styles.scanCode} />
                  <span>扫码发现更多内容</span>
                </div>
              </div>
            </div>
          </Col>
          <Col sm={8} xs={8}>
            <div className={styles.codeImg}>
              <img src={scanCode.src} className={styles.scanCode} />
            </div>
          </Col>
        </Row>}
      </div>
      {pcWidth == 'pc' && <div className={styles.friendLink}>
        <div className={styles.linkList}>
          <span>友情链接：</span>
          {friendLinkList.map(
            (link: { url: string; title: string }, key: number) => {
              return (
                <a href={link.url} key={key} target="_blank">
                  {link.title}
                </a>
              );
            }
          )}
        </div>
      </div>}
      {pcWidth == 'pc' && <div className={styles.rightBox}>
        <p className={styles.cpoyRight}>
          <span>上海三六零智语科技有限公司</span>
          <a target="_blank" href="http://www.beian.miit.gov.cn/">
            沪ICP备20010942号-1
          </a>
        </p>
        <p className={styles.icpInfo}>
          <img src="https://www.ccwork.com.cn/server/imgs/beian1.png" alt="" />{" "}
          沪公网安备 31010702003678号
        </p>
      </div>}
    </div>
  );
}
